import footerHand from '../../utils/images/footer-hand.png';
import footerEllipse from '../../utils/images/footer-Ellipse.png';
import exploreIcon from '../../utils/icons/explore-icon.png';

import './footer.css';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import { Link } from 'react-router-dom';

const Footer = () => {
  useScrollAnimation();

  return (
    <footer className='page-width px-3'>
      <section className="footer-illustration position-relative d-flex flex-column justify-content-center my-5">
        <div className="black-div"></div>
        <div className='footer-illustration_img1 d-flex justify-content-center js-scroll fade-in'><img src={footerHand} alt="footer hand" /></div>
        <div className='footer-illustration_img2 d-flex justify-content-center js-scroll fade-in-bottom'><img src={footerEllipse} alt="footer ellipse" /></div>
      </section>

      <section className="footer-info d-flex flex-column gap-4 my-0 my-md-5">
        <h2 className='text-uppercase text-center pt-5 my-5'>You are a creator, see you at the cosmos conference, 2024.</h2>
       
       <div className="socials text-center">
        <p>Follow Us On Social Media</p>
        <section className="social-links d-flex justify-content-center align-items-center gap-3">
            <Link to='https://www.instagram.com/cosmosconference?igsh=MXFxMHhjZHV0Mzg3Mg%3D%3D&utm_source=qr'><i className="fa-brands fa-2x fa-instagram"></i></Link>
            {/* <Link to='http://Facebook.com/'><i className="fa-brands fa-2x fa-facebook"></i></Link> */}
            <Link to='https://www.youtube.com/channel/UCY163yRO17BJImNOFaF6cMg'><i className="fa-brands fa-2x fa-youtube"></i></Link>
            <Link to='https://x.com/cosmosconfrence?t=LDDVMR17xDegDoj5JohiTg&s=09'><i className="fa-brands fa-2x fa-x-twitter"></i></Link>
            <Link to='http://linkedIn.com/'><i className="fa-brands fa-2x fa-linkedin-in"></i></Link>
        </section>
       </div>

        <Link to='https://chat.whatsapp.com/BRyyjMPjRwh9tAjzbzehFg' className="customBtn text-uppercase"> <span>Join Community</span> <img src={exploreIcon} alt="" /> </Link>

      </section>

      <section className="credit d-flex flex-column flex-md-row justify-content-between gap-1 my-5 pt-2">
        <p>2024 &copy; Cosmos Conference. All Rights Reserved.</p>
        <p>Website Designed by Cosmos Design Space</p>
      </section>
    </footer>
  )
}

export default Footer
